import React from "react";
import "./App.css";

function App() {
  return (
    <iframe
      src="../bot.html"
      title="bot"
      style={{ border: "none", height: "99vh", width: "100vw" }}
    ></iframe>
  );
}

export default App;
